// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toaster__alert {
  background-color: white;
  overflow: hidden;
  max-width: 650px;
  position: relative;
  border-radius: 0.4rem;
  display: flex;
  padding: 1rem;
  padding-right: 48px;
  box-shadow: rgba(52, 58, 64, 0.15) 0px 1px 10px 0px,
    rgba(52, 58, 64, 0.1) 0px 6px 12px 0px,
    rgba(52, 58, 64, 0.12) 0px 6px 15px -2px;
}

.Toaster__alert_text {
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  color: rgb(33, 37, 41);
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  line-height: 1.5;
  font-size: 1rem;
  margin: 0px;
}

.Toaster__alert_close {
  padding: 12px;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  position: absolute;
  top: 7px;
  right: 4px;
  border-radius: 0.4rem;
  border: 0;
  -webkit-appearance: none;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}

.Toaster__alert_close:focus {
  box-shadow: rgba(52, 58, 64, 0.15) 0px 0px 0px 3px;
}

.Toaster__message-wrapper {
  padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/toasted-notes/src/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB;;4CAE0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB;;2DAEyD;EACzD,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;AACd","sourcesContent":[".Toaster__alert {\n  background-color: white;\n  overflow: hidden;\n  max-width: 650px;\n  position: relative;\n  border-radius: 0.4rem;\n  display: flex;\n  padding: 1rem;\n  padding-right: 48px;\n  box-shadow: rgba(52, 58, 64, 0.15) 0px 1px 10px 0px,\n    rgba(52, 58, 64, 0.1) 0px 6px 12px 0px,\n    rgba(52, 58, 64, 0.12) 0px 6px 15px -2px;\n}\n\n.Toaster__alert_text {\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  color: rgb(33, 37, 41);\n  -webkit-font-smoothing: antialiased;\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 1rem;\n  margin: 0px;\n}\n\n.Toaster__alert_close {\n  padding: 12px;\n  outline: none;\n  cursor: pointer;\n  background-color: transparent;\n  position: absolute;\n  top: 7px;\n  right: 4px;\n  border-radius: 0.4rem;\n  border: 0;\n  -webkit-appearance: none;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.5;\n}\n\n.Toaster__alert_close:focus {\n  box-shadow: rgba(52, 58, 64, 0.15) 0px 0px 0px 3px;\n}\n\n.Toaster__message-wrapper {\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
